import React from 'react'

function Icon() {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='16'
      height='16'
      fill='none'
      viewBox='0 0 16 16'
    >
      <path
        fill='#202020'
        fillOpacity='0.5'
        d='M8 14.667A6.666 6.666 0 118 1.334a6.666 6.666 0 010 13.333zm0-1.333A5.333 5.333 0 108 2.667a5.333 5.333 0 000 10.667zm-.665-2.667L4.507 7.838l.942-.942L7.335 8.78l3.771-3.77.943.942-4.714 4.714z'
      ></path>
    </svg>
  )
}

export default Icon
